<ngx-spinner size="medium" [template]="spinnerTemplate"></ngx-spinner>
<router-outlet></router-outlet>